export default __webpack_public_path__ + "4ab12e7e439c1f05c7ad3ba0a077f147.svg";